import React from 'react';
import { View, StyleSheet, Image, TouchableWithoutFeedback, TouchableOpacity, ScrollView, ActivityIndicator } from 'react-native';
import { Surface, Avatar, Searchbar } from 'react-native-paper';
import { Text, Styles } from './../../components/UI-Components';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import Icons from "react-native-vector-icons/FontAwesome";
import { connect } from 'react-redux';
import { getCourseMaterial, clearAllCourseMaterialData } from './../../store/actions';
import { courseMaterials } from './../../store/selector';
// import ToasterComponent from './../snackBarComponent';
// import BackHandlerAndroid from './../AndroidBackHandler';
// import OfflineHandler from './../OfflineHandler';
// import AdsScreen from './../Ads';
import Toaster from './../../components/snackBar_toaster';
import PlayArrow from  '@material-ui/icons/PlayArrow';
import PictureAsPdf from  '@material-ui/icons/PictureAsPdf';
import Description from  '@material-ui/icons/Description';
import Lock from  '@material-ui/icons/Lock';
import NavigateNext from  '@material-ui/icons/NavigateNext';
import ShowContentScreen from './../showContentScreen';
import Header from "./../../components/Header";






class LessonContent extends React.Component {
    state = {
        query: '',
        materials: [],
        showToast: false,
        toasterMessage: ''
    }

    componentDidMount() {
         this.getCourseMaterials();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.materials !== this.props.materials) {
            this.setState({
                materials: this.props.materials
            })
        
        }
    }

    componentWillUnmount() {
        this.props.clearAllCourseMaterialData();
    }

    getCourseMaterials = () => {
        // const lessonPlannerId = this.props.navigation.getParam('lessonPlannerId', null);
        const { state = {}} = this.props.location;
        const { lessonPlannerId=null} = state;
        if(lessonPlannerId) {
            this.props.getCourseMaterial(lessonPlannerId);
        }
    }

    showToaster = (msg) => {
        this.setState({
          showToast: true,
          toasterMessage: msg
        })
      }

    handleSearch = (text) => {
        const formatData = text.toLowerCase();

        this.setState({ query: text }, () => {
            const filteredData = this.props.materials && this.props.materials.length && this.props.materials.filter(x => {
                if (x && x.title && x.title.toLowerCase().includes(formatData)) {
                    return x;
                }
            })
            this.setState({ 
                materials: filteredData
            })
        })

    }

    // showToaster = (msg, time=1000) => this.refs.toast.show(msg, time)

    isAdAvailable = (value) => {
        this.setState({
            isAdShow: value
        })
     }

    render() {    
        const { isUserPaid, isFree, loading, errInfo, error } = this.props;
        const { materials } = this.state;    
        return(
            <>
            <Header
                title="Course Content"
                headerRight
                headerRightClick={() => this.props.history.push('/Home')}
                headerLeftClick={() => this.props.history.goBack()}
                backButton={true}
                // headerRightClick={() => alert()}
                back
             />
            <div className='main-component'
               
            >
         
            <ScrollView >
                {/* {
                   !this.props.loading && !this.props.error && 
                    <Searchbar
                        placeholder="Search..."
                        onChangeText={_query => { this.setState({ query: _query }) }}
                        value={this.state.query}
                        style={{ margin: 8 }}
                        onChangeText = { this.handleSearch}
                        // onFocus={() => {
                        //     this.setState({
                        //         isSearch: true
                        //     })
                        // }}
                    />
                } */}
                {
                    loading && <View style={styles.container}><ActivityIndicator /></View>
                }

                {
                    error && <View style={styles.container}><Text>{errInfo && typeof errInfo === 'string' ? errInfo : 'something went wrong...'}</Text></View>
                }

                <View style={{paddingHorizontal: 12, paddingBottom: this.state.isAdShow ? 40 : 0}}>   
                    {
                        materials && materials.length > 0 && materials.map(material => {
                            const {title, file_type, content_url,
                                 html_content, is_paid,course_id, exam_id, lesson_planner_id, id} = material;
                            return ( 
                            <TouchableWithoutFeedback
                                onPress = {()=> {            
                                                       
                                    if(isFree || isUserPaid || !is_paid) {
                                        // this.props.navigation.navigate('ShowContentScreen', {
                                        //     contentUrl: content_url,
                                        //     contentType: file_type,
                                        //     html_content: html_content,
                                        //     title: title,
                                        //     id: id,
                                        //     subjectId: course_id,
                                        //     examId: exam_id,
                                        //     topicId: lesson_planner_id,
                                        //     formLibrary: false,
                                        // })
                                        this.setState({
                                            showContent: true,
                                            contentData: {
                                               contentUrl: content_url,
                                               contentType: file_type,
                                               html_content,
                                               title,
                                               id,
                                               subjectId: course_id,
                                               examId: exam_id,
                                               topicId: lesson_planner_id,
                                               formLibrary: false,
                                            }
                                        })
                                        return null;
                                    }
                                    return this.showToaster('Please purchase to Continue.');
                                  

                                }}
                            >
                                <View style={styles.courseWrapper}>
                                    
                                        {
                                            file_type === 'video'
                                            ?
                                            <PlayArrow style={{color:'#233767', width: 48, height: 48}}/>
                                            :
                                            file_type === 'pdf'
                                            ?
                                            <PictureAsPdf style={{color: '#df3c38',  width: 48, height: 48}}/>
                                            :
                                            <Description style={{color: '#4176bc',  width: 48, height: 48}}/>
                                        }
                                        <View style={styles.titleWrapper}>
                                            <Text 
                                            ellipsizemode={'tail'}
                                            numberOfLines={2}
                                            style={styles.title}
                                             
                                            >{title}</Text>                                        
                                        </View>
                                        {
                                            (isUserPaid || isFree || !is_paid)
                                            ?
                                             <NavigateNext style={{marginLeft: 'auto', alignSelf: 'center', color:'rgba(0,0,0,0.7)', width: 20, height: 20}}/>
                                            :
                                            <Lock style={{marginLeft: 'auto', alignSelf: 'center', color:'rgba(0,0,0,0.7)', width: 20, height: 20}}/>
                                        }
                                    </View>
                            </TouchableWithoutFeedback>  
                        )   
                        })
                    }
                                     
                </View>
     
            </ScrollView>
            {/* <AdsScreen screenName={'LessonContent'}
              
               isAdCallBack={() => this.isAdAvailable(true)}
               /> */}
            <Toaster show={this.state.showToast}
              message={this.state.toasterMessage}/>
  
            </div>
            {
                this.state.showContent ?
                 <ShowContentScreen
                 contentData={this.state.contentData}
                 open={this.state.showContent}
                 handleClose={() => this.setState({showContent: false})}
                 />
                 : null
            }
            </>

        )
    }
}

const mapStateToProps = state => {
    const { isUserPaid, isFree, materials } = courseMaterials(state);
    return {
        isUserPaid, isFree, materials,        
        loading: state.courseMaterial && state.courseMaterial.loading,
        error: state.courseMaterial && state.courseMaterial.error,
        errInfo: state.courseMaterial && state.courseMaterial.errInfo && state.courseMaterial.errInfo.data && state.courseMaterial.errInfo.data.message,
    }
}

export default connect(mapStateToProps, {getCourseMaterial, clearAllCourseMaterialData})(LessonContent)

const styles = StyleSheet.create({
    courseWrapper: {
        paddingHorizontal: 8,
        paddingVertical: 12,
        justifyContent: 'flex-start',
        // alignItems: '',
        flexDirection: 'row',
        borderWidth: 0.2,
        borderRadius: 10,
        marginBottom: 12,
        borderColor: '#ccc',
        marginTop: 10,
        cursor: 'pointer',

    },
    titleWrapper: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignSelf: 'center',
        marginLeft: 20,
        flex: 1,
    
    },
    title: {
        fontSize: 18,
        color: 'rgba(0,0,0,0.7)',
        fontWeight: '500',
        paddingRight: 5
        
     
    },
    container: {
        flex: 1, 
        justifyContent: 'center', 
        alignItems: 'center'
    }
})